.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 8px var(--gutter) 20px;
  text-align: center;
}

.name {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-xl);
  font-weight: 800;
  letter-spacing: -0.02em;
}

.stats {
  display: flex;
  gap: 28px;
}

.stats > * {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.stats strong {
  font-size: var(--fs-lg);
  font-weight: 800;
}

.stats span span {
  font-size: var(--fs-xs);
  color: var(--text-3);
  font-weight: 600;
}

.stats a span {
  font-size: var(--fs-xs);
  color: var(--text-3);
  font-weight: 600;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.proBadge {
  padding: 2px 7px;
  border-radius: var(--r-full);
  background: var(--accent);
  color: var(--accent-ink);
  font-size: var(--fs-xs);
  font-weight: 800;
  letter-spacing: 0.06em;
}

.supporters {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-xs);
  font-weight: 700;
  color: var(--text-2);
}

.supporters svg {
  color: var(--accent);
}

.bio {
  max-width: 320px;
  font-size: var(--fs-sm);
  line-height: 1.5;
  color: var(--text-2);
  white-space: pre-line;
}

.tabBody {
  min-height: 50dvh;
}

.privBadge {
  position: absolute;
  top: 6px;
  right: 6px;
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgb(0 0 0 / 0.55);
}

.playlistGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(148px, 1fr));
  justify-items: center;
  gap: 16px 12px;
  padding: 16px var(--gutter);
}

/* ---------- edit / settings ---------- */
.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px var(--gutter) 24px;
}

.avatarEdit {
  position: relative;
  align-self: center;
  border-radius: 50%;
}

.avatarBadge {
  position: absolute;
  right: 0;
  bottom: 0;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: 0 0 0 3px var(--bg);
}

.settingsList {
  list-style: none;
  margin: 0;
  padding: 0 8px;
}

.settingsGroup {
  margin: 20px var(--gutter) 6px;
  font-size: var(--fs-xs);
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-3);
}

.settingsItem {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 12px;
  border-radius: var(--r-md);
  font-weight: 600;
  text-align: left;
}

.settingsItem:hover {
  background: var(--surface-1);
}

.settingsItem small {
  margin-left: auto;
  color: var(--text-3);
  font-weight: 500;
}

.danger {
  color: var(--danger);
}

.version {
  text-align: center;
  color: var(--text-3);
  font-size: var(--fs-xs);
  margin-top: 28px;
}
